import { z } from "zod";

export const setLabelPositionConfigurationSchema = z.object({
	xPositionExpression: z.string(),
	yPositionExpression: z.string(),
});
